<template lang="pug">
  #authenticate
    .container
      .col-md-4.col-xs-8.login-portion
        .login-form.panel.row-inlineblock
          .panel-heading
            h2.panel-title ログイン
          .panel-body
            form(novalidate)
              .form-group
                label.control-label(for='name') グループID
                .input-group
                  span.input-group-addon
                    span.fa.fa-user.fa-fw
                  input#name.form-control(required type='text' v-model='groupId' placeholder='グループIDを入力してください'
                    v-bind:class='{valid:!$v.groupId.$invalid, invalid:$v.groupId.$invalid}')
              hr
              p 個人用ログイン情報を入力してください。
              .form-group
                label.control-label(for='email') メールアドレス
                .input-group
                  span.input-group-addon
                    span.fa.fa-envelope.fa-fw
                  input#email.form-control(required type='text' v-model='mail' placeholder='メールアドレスを入力してください'
                    v-bind:class='{valid:!$v.mail.$invalid, invalid:$v.mail.$invalid}')
              .form-group
                label.control-label(for='password') パスワード
                .input-group
                  span.input-group-addon
                    span.fa.fa-lock.fa-fw
                  input#password.form-control(required type='password' v-model='password' placeholder='パスワードを入力してください'
                    v-bind:class='{valid:!$v.password.$invalid, invalid:$v.password.$invalid}')
              .form-group
                .alert.alert-danger(v-show='message' v-html='message')
                //- login
                button#button.btn.btn-success.btn-lg.btn-block.login-button.login-form-button(type='button' @click='signin()'
                  v-show='!$v.$invalid') ログイン
                p.text-center
                  //- lostpassword
                  router-link(to='/auth/lost_password') パスワードをお忘れの方はこちら
</template>

<style lang="stylus" scoped>
</style>

<script>
import Authenticate from '@/service/Authenticate'
import Loader from '@/service/Loader'
import { required } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      groupId: '',
      mail: '',
      password: '',
      message: null
    }
  },
  validations: {
    groupId: { required },
    mail: { required },
    password: { required }
  },
  methods: {
    signin () {
      Loader.show()
      let siginResult = Authenticate.doSignin(this.groupId, this.mail, this.password)
      siginResult.then((is) => {
        if (is) {
          this.$router.push('/dashboard')
        } else {
          this.message = 'ログインに失敗しました'
          Loader.hide()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?02039284